export const phoneRegExp = /^\+?\d(?:\d| \d){6,14}$/;
